import { connect } from 'react-redux';

import ErrorBanner from 'presentation/components/ErrorBanner';
import reconnectChatClient from 'actions/app/reconnectChatClient';
import { getCustomText } from 'app/modules';

export const mapStateToProps = state => {
  let errorText = getCustomText(state).errors;

  return {
    buttonText: errorText.connectionRetryButton,
    errorMessage: errorText.connectionError,
    shouldShowSvg: false,
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onClick: () => dispatch(reconnectChatClient),
  };
};

const ConnectionErrorBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorBanner);

export default ConnectionErrorBannerContainer;
